import { Header5, ProfSearch16 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './Footer.css';

interface IFooterProps {
  professionalSearchUrl: string;
  isProfessionalSearchButtonVisible: boolean;
  onProfessionalSearchClick(): void;
  onClearClick(): void;
  onShowClick(): void;
}

export const Footer: React.FC<IFooterProps> = ({
  onClearClick,
  onShowClick,
  professionalSearchUrl,
  isProfessionalSearchButtonVisible,
  onProfessionalSearchClick,
}) => {
  const buttons = (
    <>
      <Button size="XS" theme="fill_white_primary" onClick={onClearClick}>
        Сбросить фильтры
      </Button>
      <Button size="XS" theme="fill_primary" onClick={onShowClick}>
        Показать объекты
      </Button>
    </>
  );

  if (isProfessionalSearchButtonVisible) {
    return (
      <div className={styles['container--dual-side']}>
        <a className={styles['profsearch_link']} onClick={onProfessionalSearchClick} href={professionalSearchUrl}>
          <ProfSearch16 color="primary_100"></ProfSearch16>
          <Header5 color="primary_100">Профпоиск для риелторов</Header5>
        </a>
        <div className={styles['primary_buttons']}>{buttons}</div>
      </div>
    );
  }

  return <div className={styles['container']}>{buttons}</div>;
};
